import React, { Fragment, memo } from 'react';
import { useForm } from 'react-hook-form';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { RoleDTO } from '@app/common';
import { Button, Form, Panel } from '@app/components';
import { RoleForm } from './RoleForm';
import { useToast, useTriptych } from '@app/hooks';
import { RoleCard } from './RoleCard';
import { transformRoleFormValuesToPayload, RoleFormValues } from './role-form.helpers';
import { roleApi } from '@app/store';

export const RoleCreate = memo(() => {
  const toast = useToast();

  const triptych = useTriptych()

  const [create, { isLoading, error: apiErrors }] = roleApi.useCreateOneRolesMutation();

  const formMethods = useForm<RoleFormValues>({
    resolver: classValidatorResolver(RoleDTO),
    defaultValues: {
      name: '',
      permissions: {}
    },
  });

  const onCreate = async (formValues: RoleFormValues) => {
    try {
      const role = await create(transformRoleFormValuesToPayload(formValues)).unwrap();

      triptych.close({ mode: 'UPDATE', data: role });

      toast.success('Votre rôle a bien été ajouté.')
    } catch {
      toast.error('Une erreur est survenue lors de la création de votre rôle.')
    }
  }

  return (
    <Fragment>
      <RoleCard
        formMethods={formMethods}
        toggle={() => triptych.toggle()} />

      <Form formMethods={formMethods} apiErrors={apiErrors}>

        <Panel.Content>

          <Panel.FormContainer>

            <RoleForm />

          </Panel.FormContainer>

          <Panel.Actions>
            <Button
              title="Retour"
              grow
              large
              bordered
              onPress={() => triptych.close()} />

            <Button
              title="Valider"
              loading={isLoading}
              onPress={formMethods.handleSubmit(onCreate)}
              grow
              large />
          </Panel.Actions>

        </Panel.Content>

      </Form>

    </Fragment>
  );
});
